import { useState } from "react";

import { Await, useNavigate } from "react-router-dom";

import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

import pepIcon from "../../images/pacienteLogin/logo.png";
import imgHome from "../../images/pacienteLogin/foto.png";
import { InfoOutlined } from "@mui/icons-material";

import InputMask from "react-input-mask";
import { cpf } from "cpf-cnpj-validator";

import api from "../../services/api";
import ModalDialogs from "../../components/ModalDialogs";
import { localStorageRemoveItem, setItemEncryp } from "../../utils/cryptoData";

//import { createInputMask } from "imask";

const styles = {
  container: {
    height: "100vh",
    width: "100%",
  },
  pepIcon: {
    width: "232px",
    height: "auto",
  },
  title: {
    color: "#1e729f",
    fontFamily: "Nunito",
    fontSize: "30px",
    fontWeight: 600,
    lineHeight: "30px",
  },
  subTitle: {
    fontFamily: "Nunito",
    fontSize: "16px",
    fontWeight: 600,
    color: "#063F5E",
  },
  cpfStack: {},
  button: {
    backgroundColor: "#1e729f",
    textTransform: "initial",
    width: "100%",
  },
  buttonOutLined: {
    textTransform: "initial",
    width: "100%",
  },
  textField: { height: "40px" },
};

export default function PacienteLogin(params) {
  const [cpfLogin, setCpfLogin] = useState("");
  const [send, setSend] = useState(false);
  const [senha, setSenha] = useState("");
  const [modalError, setModalError] = useState({
    open: false,
    message: "",
  });

  const navigate = useNavigate();

  const handleChange = (event) => {
    const inputCpf = event.target.value;
    setCpfLogin(inputCpf);
  };
  const handleLogin = async (e) => {
    e.preventDefault();
    setSend(true);

    if (cpfLogin.length < 14) {
      setModalError({
        open: true,
        message: "CPF inválido",
      });
      return;
    } else if (!cpf.isValid(cpfLogin)) {
      setModalError({
        open: true,
        message: "CPF inválido",
      });
      return;
    }

    const loginData = {
      cpf: cpfLogin,
      senha: senha,
    };

    try {
      const response = await api.post("/login-paciente", loginData);

      if (response.data.status !== "Error") {
        clearLocalStorage();
        api.defaults.headers.authorization = `Bearer ${response.data.jwt}`;
        localStorage.setItem("jwt", JSON.stringify(response.data.jwt));
        setItemEncryp("usuario", response.data.usuario);
        setItemEncryp("paciente", response.data.paciente);

        window.location.replace("/paciente/home");
      } else {
        setModalError({
          open: true,
          message: response.data.message,
        });
      }
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    } finally {
      setSend(false);
    }
  };

  const clearLocalStorage = () => {
    localStorage.removeItem("sabiaTokenExpirationTime");
    localStorage.removeItem("sabiaScope");
    localStorage.removeItem("sabiaToken");
    localStorage.removeItem("usuario");
    localStorage.removeItem("vinculo_ativo");
    localStorage.removeItem("jwt");
    localStorage.removeItem("paciente");
    // removendo com criptografia
    localStorageRemoveItem("usuario");
    localStorageRemoveItem("vinculo_ativo");
    localStorageRemoveItem("paciente");
    api.defaults.headers.authorization = null;
  };

  return (
    <Stack sx={styles.container}>
      <Stack
        direction={{ xs: "column", md: "row" }}
        component="form"
        onSubmit={handleLogin}
        alignItems="center"
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backdropFilter: "blur(10px)",
            boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.15)",
            transition: "all 0.1s ease",
          }}
          height={{ xs: "90vh", sm: "80vh", md: "100vh" }}
          overflow={{ sx: "auto", md: "hidden" }}
          position={{ xs: "absolute", md: "static" }}
          width={{ xs: "90vw", sm: "80vw", md: "40vw" }}
          bgcolor={{ xs: "rgba(255, 255, 255, 0.5) !important", md: "#ffff" }}
          marginTop={{ xs: "5vh", md: "0" }}
          borderRadius={{ xs: "20px", md: "0 0" }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
            bgcolor={{ xs: "transparent !important", md: "#ffff" }}
            gap={{ xs: "20px", sm: "32px" }}
          >
            <Icon sx={styles.pepIcon}>
              <img src={pepIcon} alt="pepIcon" styles={styles.pepIcon} />
            </Icon>
            <Typography sx={styles.title}>Login do usuário</Typography>
            <Stack width={"100%"} display={"flex"}>
              <Typography sx={styles.subTitle}>CPF</Typography>
              <InputMask
                mask="999.999.999-99"
                maskChar=""
                value={cpfLogin}
                onChange={handleChange}
                required
              >
                {(inputProps) => (
                  <TextField
                    id={"cpf"}
                    {...inputProps}
                    fullWidth
                    placeholder={"Informar cpf"}
                    sx={styles.textField}
                    autoComplete="off"
                  />
                )}
              </InputMask>
            </Stack>
            <Stack width={"100%"}>
              <Typography sx={styles.subTitle}>Senha</Typography>
              <TextField
                required
                id="senha"
                type="password"
                placeholder={"informar senha"}
                value={senha}
                onChange={(event) => {
                  setSenha(event.target.value);
                }}
              />
            </Stack>
            <Button
              type="submit"
              sx={styles.button}
              variant="contained"
              display={send}
              startIcon={
                send ? <CircularProgress color="inherit" size={20} /> : null
              }
            >
              Entrar
            </Button>
            <Divider orientation="horizontal" flexItem />
            <Typography
              sx={{
                display: "flex",
                direction: "row",
                alignItems: "center",
                color: "#737373",
                fontSize: "20px",
                fontWeight: "600px",
              }}
            >
              Esqueceu a senha? Recupere aqui.
            </Typography>
            <Button
              variant="outlined"
              onClick={() => {
                navigate("/cadastroPaciente");
              }}
              sx={styles.buttonOutLined}
            >
              Criar conta
            </Button>
            <Tooltip>
              <Box
                bgcolor={{
                  xs: "transparent !important",
                  md: "#ffff",
                }}
              >
                <Typography
                  sx={{
                    display: "flex",
                    direction: "row",
                    alignItems: "center",
                    color: "#737373",
                    fontSize: "20px",
                    fontWeight: "600px",
                  }}
                >
                  <InfoOutlined
                    fontSize="small"
                    sx={{ color: "#737373", mr: 0.5 }}
                  />{" "}
                  Leia nossa política de privacidade
                </Typography>
              </Box>
            </Tooltip>
          </Box>
        </Box>
        <Box width={{ xs: "100vw", md: "60vw" }} height="100vh">
          <img
            src={imgHome}
            alt="foto"
            style={{ width: "100%", height: "100vh" }}
          />
        </Box>
      </Stack>
      <ModalDialogs
        open={modalError.open}
        onClose={() => setModalError({ open: false, message: "" })}
        onActionPrimary={() => setModalError({ open: false, message: "" })}
        modalType="error"
        title="Error"
        body={modalError.message}
        primaryButtonText="Fechar"
      />
    </Stack>
  );
}
